import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';
import cn from 'clsx';
import CollapseAppTools from './CollapseAppTools';
import useIsMobile from '../../../hooks/useIsMobile';

export interface IAppToolbar {
    isExpanded: boolean;
    onCollapse?: (newIsExpand: boolean) => void;
    showExpandAnimation: boolean;
    showCollapseAnimation: boolean;
}

const AppToolbar = ({
    isExpanded,
    onCollapse = () => {},
    showExpandAnimation,
    showCollapseAnimation,
    children,
}) => {
    const isMobile = useIsMobile();
    const classes = useStyles({ isMobile });

    return (
        <div
            className={cn(classes.container, {
                [classes.expanded]: isExpanded && !showCollapseAnimation,
                [classes.expand]: showExpandAnimation,
                [classes.collapse]: showCollapseAnimation,
            })}
        >
            <div className={classes.childrenContainer}>{children}</div>
            {isExpanded && !isMobile && <CollapseAppTools onClick={onCollapse} />}
        </div>
    );
};

const useStyles = makeStyles<Theme, { isMobile: boolean }>(
    theme => ({
        '@keyframes expandBorderRadius': {
            from: {
                borderRadius: ({ isMobile }) =>
                    isMobile ? '33px 33px 0px 0px' : '33px 0px 0px 33px',
            },
            to: {
                borderRadius: 0,
            },
        },
        '@keyframes collapseBorderRadius': {
            from: {
                borderRadius: 0,
            },
            to: {
                borderRadius: ({ isMobile }) =>
                    isMobile ? '33px 33px 0px 0px' : '33px 0px 0px 33px',
            },
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,

            minWidth: 100,
            height: '100%',
            background: 'white',
            padding: '28px 0 28px',
            borderRadius: '33px 0px 0px 33px',

            borderLeft: `1px solid #D7D7D7`,

            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row',
                width: '100%',
                height: 66,
                borderRadius: '33px 33px 0px 0px',
                padding: '0 28px 0 28px',
                boxShadow: '0px -4px 14px rgba(0, 0, 0, 0.1)',

                borderLeft: 0,
                borderTop: `1px solid #D7D7D7`,
            },
        },
        childrenContainer: {
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row',
                flexGrow: 2,
                justifyContent: 'space-evenly',
            },
        },
        expanded: {
            [theme.breakpoints.down('sm')]: {
                borderTop: `1px solid #D7D7D7`,
                justifyContent: 'center',
            },
            borderRadius: 0,
        },
        expand: {
            animation: '$expandBorderRadius 0.2s',
            animationFillMode: 'forwards',
        },
        collapse: {
            animation: '$collapseBorderRadius 0.2s',
            animationFillMode: 'forwards',
        },
    }),
    {
        classNamePrefix: 'AppToolbar',
    }
);
export default AppToolbar;
